import { Icon, List, Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import i18next from "i18next";
import { translationMapping } from "src/utils/translation-mappings";
import { dseds } from "@ucl/shared-component-foundations";

const ListComponent = ({ items, type }: any) => {
  return (
    <List size="medium" type={type}>
      {items.map((item: any) => (
        <List.Item key={item} ><Text.P size="large" className="inline">{item}</Text.P></List.Item>
      ))}
    </List>
  );
};

export const CaseInfoBanner = ({ translationKey }: { translationKey: string; }) => {
  const { t } = useTranslation("translation", { keyPrefix: `${translationKey}` });
  const { t: genericT } = useTranslation();

  const iconType = translationKey.includes("inProgress") || translationKey.includes("beforeYouContinue") ? "clock" : "information";
  const iconColour = dseds.semanticMode1.color.icon.onLight.interactive.value;

  const renderContent = () => {
    const elements = [];
    let i = 1;

    while (i18next.exists(`${translationKey}.infoPara${i}`) || i18next.exists(`${translationKey}.infoBulletList${i}`)) {
      if (i18next.exists(`${translationKey}.infoPara${i}`)) {
        elements.push(
          <Text.P key={`para-${i}`} size="large">
            <Trans i18nKey={`${translationKey}.infoPara${i}`} components={translationMapping(genericT)} />
          </Text.P>
        );
      }
      if (i18next.exists(`${translationKey}.infoBulletList${i}`)) {
        const bullets = t(`infoBulletList${i}`, { returnObjects: true });
        if (Array.isArray(bullets)) {
          elements.push(
            <ListComponent items={bullets} type="bullet" />
          );
        }
      }
      i++;
    }
    return elements;
  };

  return (
    <div className="flex flex-col text-start gap-5 p-5 bg-gray-100 rounded-xl" data-testid="caseInfoBanner">
      <div className="flex gap-2 items-center">
        <Icon icon={iconType} size="l" className="min-w-[24px]" color={iconColour} />
        <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
          {t("infoTitle")}
        </Text>
      </div>
      <div className="flex flex-col gap-3">
        {renderContent()}
      </div>
    </div>
  );
};
